var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavNewzIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.107,
    height: 80.844,
    viewBox: "0 0 76.107 80.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newspaper_652830",
    transform: "translate(-15 -0.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29039",
    "data-name": "Group 29039",
    transform: "translate(15 9.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29038",
    "data-name": "Group 29038",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39868",
    "data-name": "Path 39868",
    d: "M15,60v61.9a4.737,4.737,0,1,0,9.474,0V60Z",
    transform: "translate(-15 -60)",
    fill: "#1dcca8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29041",
    "data-name": "Group 29041",
    transform: "translate(43.422 23.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29040",
    "data-name": "Group 29040",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3020",
    "data-name": "Rectangle 3020",
    width: 34,
    height: 14,
    transform: "translate(-0.422 0.315)",
    fill: "#1dcca8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29043",
    "data-name": "Group 29043",
    transform: "translate(19.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29042",
    "data-name": "Group 29042",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39869",
    "data-name": "Path 39869",
    d: "M54.58,0l-.106,2.315V71.37A9.485,9.485,0,0,1,45,80.844h64.265a7.113,7.113,0,0,0,7.105-7.105V0ZM83.053,71.37H63.948V66.633H83.053Zm0-9.474H63.948V57.159H83.053Zm0-9.474H63.948V47.685H83.053ZM106.9,71.37H87.79V66.633H106.9Zm0-9.474H87.79V57.159H106.9Zm0-9.474H87.79V47.685H106.9Zm0-9.474H63.948v-24H106.9Zm0-28.737H63.948V9.474H106.9Z",
    transform: "translate(-45 0.344)",
    fill: "#1dcca8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavNewzIcon);
export default __webpack_public_path__ + "static/media/favNewz_icon.9f092acf2cc4d49097135a1ae9ad94b8.svg";
export { ForwardRef as ReactComponent };